import { Component, OnInit, Output, EventEmitter, HostListener, OnDestroy } from '@angular/core';
import { eventTypesIcons } from '../../../models/events.mockup';
import { CalendarUtilsService } from 'src/app/services/calendar-utils.service';
import { EventDetails } from 'src/app/models/events.model';
import { EventsService } from 'src/app/services/events.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment.prod';
import { AgendaUtilsService } from 'src/app/services/agenda-utils.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ComponentsCommunicationService } from 'src/app/services/components-communication.service';

@Component({
  selector: 'transflo-normal-agenda',
  templateUrl: './normal-agenda.component.html',
  styleUrls: ['./normal-agenda.component.scss']
})
export class NormalAgendaComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  loadEvents = true;
  paginationShouldLoad = true;
  currentDay: any;
  eventslist = [];
  eventTypesIconClasses = eventTypesIcons;
  calendarView: string;
  paginationHeader: any;
  @Output() openUpdateEventModal = new EventEmitter();
  documentMetadata: any[] = [];
  documentName: string = "";
  showPopup: boolean = false;
  eventId: number;
  refreshSubscription: Subscription;
  constructor(
    private calendarUtils: CalendarUtilsService,
    private eventsService: EventsService,
    private agendaUtils: AgendaUtilsService,
    private router: Router,
    private communicationService: ComponentsCommunicationService
  ) { }

  ngOnInit(): void {
    this.refreshSubscription = this.communicationService.refresh$.subscribe(() => {
      this.refreshAgenda();
    });
    this.refreshAgenda();
  }

  refreshAgenda(): void {
    this.populateAgenda([]);
    this.calendarUtils.calendarChangeEvents
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(value => { this.populateAgenda(value); });
    this.calendarUtils.calendarDayClicked
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(value => { this.populateAgenda(value); });

    this.calendarUtils.calendarViewSubject
      .subscribe(value => this.calendarView = value);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  populateAgenda(dayValue: any): void {
    window.scrollTo(0, 0);
    this.currentDay = dayValue;
    this.eventsService.getEvents({
      fromDate: moment(dayValue).format('YYYY-MM-DD'),
      toDate: moment(dayValue).add(environment.agendaDaysToShow, 'days').format('YYYY-MM-DD')
    }).subscribe(result => {
      this.loadEvents = false;
      this.paginationHeader = JSON.parse(result.headers.get('x-pagination'));
      this.eventslist = this.agendaUtils.constructEventsList(result.body);
      this.agendaUtils.setActiveEvent(this.eventslist);
      this.agendaUtils.setTimeUntilNextEvent(this.eventslist);
    });
  }

  editEvent($event: EventDetails): void {
    this.openUpdateEventModal.emit({ event: $event, shouldOpenModal: true });
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
      if (this.paginationHeader && this.paginationHeader.HasNextPage && this.paginationShouldLoad) {
        this.paginationShouldLoad = false;
        this.eventsService.getEvents({
          fromDate: moment(this.currentDay).format('YYYY-MM-DD'),
          toDate: moment(this.currentDay).add(environment.agendaDaysToShow, 'days').format('YYYY-MM-DD'),
          pageNumber: this.paginationHeader.CurrentPage + 1
        }).subscribe(result => {
          this.paginationHeader = JSON.parse(result.headers.get('x-pagination'));
          this.eventslist = [...this.eventslist, ...this.agendaUtils.constructEventsList(result.body)];
          this.eventslist = this.agendaUtils.mergeArrayEvents(this.eventslist);
          this.agendaUtils.setActiveEvent(this.eventslist);
          this.agendaUtils.setTimeUntilNextEvent(this.eventslist);
          this.paginationShouldLoad = true;
        });
      }
    }
  }

  onCompleteEvent(event: EventDetails): void {
    this.eventsService.getEvent(event.Id).subscribe(
      (response) => {
        if (response && response.body && response.body.Action && response.body.Action.Document &&
          response.body.Action.Document.MetaData && response.body.Action.Document.MetaData.length > 0) {
          this.documentMetadata = response.body.Action.Document.MetaData;
          this.documentName = response.body.Action.Document.Name;
          this.showPopup = true;
          this.eventId = event.Id;
        }
        else if (response && response.body && response.body.Action && response.body.Action.Document &&
          response.body.Action.Document.MetaData && response.body.Action.Document.MetaData.length == 0) {
            const fleetId = localStorage.getItem('fleetId');
            const token = localStorage.getItem('token');
            const appScheme = 'transflomobileplus';
            let deepLinkUrl = `${appScheme}://scan?recipientid=${fleetId}&return=confnumber&fleetId=${fleetId}&token=${token}&eventId=${this.eventId}`;
  
            window.location.href = deepLinkUrl;
        }
        else {
          this.eventsService.CompleteEvent(event.Id).subscribe(resp => {
            if (resp && resp.status === 204) {
              this.refreshAgenda();
              this.communicationService.triggerRefresh();            }
          });
        }
      },
      (error) => {
        console.error("Error fetching event data", error);
      }
    );
  }

  onClosePopup(): void {
    this.showPopup = false;
  }

  onSubmitForm(formData: any): void {
    console.log("Form submitted with data:", formData);
  }

  openEventDetails(eventId: number) {
    this.router.navigate(['/event-details', eventId]);
  }
}
